<template>
  <ul>
    <li v-for="(member, index) in getCurrentGroupMembers" :key="index" class="group-member">
      <div class="member d-flex flex-wrap w-100 ">
        <div class="friend-info-container">
          <div class="author-thumb profile-img">
            <router-link :to="`/s-app/profile-page/${member.user.id}`">
              <SUserAvatar :myUser="member.user" size="small" :isProfileAvatar="false" :tryModeratorBadge="true"/>
            </router-link>
          </div>
          <div class="notification-event">
            <router-link :to="`/s-app/profile-page/${member.user.id}`">
              <a class="h6 notification-friend" data-cy="memberUsername">
                {{ getUserName(member.user) }}
                <span v-if="member.sUserId === getModerator.id"> (Moderator)</span>
              </a>
              <span class="friend-username">@{{member.user.username}}</span>
            </router-link>
          </div>
        </div>
        <div class="buttons-container">
          <div
          v-if="member.sUserId !== loggedUser.id && (loggedUser.id === getModerator.id || member.sUserId === getModerator.id)"
          >      
          <SButtonMaterial          
          class="send-msg-item-btn"
          :md-ripple="false"
          buttonType="button"
          textColor="white"
          iconColor="primary"
          iconWithoutText="chat"
          svgIcon="/svg-icons/message-icon.svg"
          materialClass="dense"
          iconSize="custom"
          @button="openChat(getCurrentGroup, member.sUser)"
          :data-cy="`newItemChatButton-${getCurrentGroup.name}`"
          />
        </div>
        <button
        v-if="loggedUser.id === getModerator.id && member.sUserId !== getModerator.id"
        class="dropdown-item"
        href="#"
        @click.prevent="$emit('button', member.sUserId)"
        >
        <md-icon id="delete-icon">delete</md-icon>
        <md-tooltip md-direction="right" class="s-tooltip tp-chat-position">Remove member</md-tooltip>
      </button>
        </div>
      </div>
  </li>
  </ul>
</template>

<script>
import UserHelperVue from "../../mixins/UserHelper.vue";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import SButtonMaterial from '../../material-components/atoms/SButtonMaterial.vue';
export default {
  name: "MembersList",
  mixins: [UserHelperVue, GroupHelperVue, ChatHelperVue],
  components: {
    SUserAvatar,
    SButtonMaterial,
  },
  data(){
    return{
      selectedKeyChat:{},
    }
  },
  methods: {    
    openChat(key, member) {
      const selectedKeyId = key.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: member,
      };

      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$parent.$parent.$refs.rightStickyBar.openClosePopup();
    },
  },
};
</script>

<style scoped>
.member{
  flex-direction: row;
  justify-content: space-between;
}
.send-msg-item-btn {
  min-width: 60px;
}

.md-button {
  margin: 0;
}
.buttons-container {
  display: flex;
  align-items: center;
}
.dropdown-item {
  padding: 0;
}

#delete-icon {
  cursor: pointer;
  color: red;
  font-size: 33px !important;
  margin-bottom: 10px;
}

.friend-info-container {
  display: flex;
  align-items: center;
}

.author-thumb {
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-member {
  background-color: white;
  border: 1.5px solid #d3d4d7;
  border-radius: 4px;
  margin: 15px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notification-friend {
  color: black !important;
  font-weight: bold !important;
  font-size: 16px;
}

.notification-friend span{
  color: gray;
  font-weight: 400;
}

.friend-username {
  color: gray;
}
.my-chat-button {
  cursor: pointer;
}

.chat-message {
  width: 40px;
  height: 36px;
}
.profile-img {
  height: 45px;
  width: 45px;
}
.avatar-container {
  margin-right: 10px;
  position: relative;
}


@media screen and (max-width: 460px) {
.notification-friend{
  font-size: 14px;
}
}

@media screen and (max-width: 340px) {
  .member{
    flex-direction: column;
    /* justify-content: center; */
    align-content: center;
  }
  .friend-info-container{
    margin-bottom: 16px;
  }
}

</style>
